/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_TitleInputs */

const he_contact_success_title = /** @type {(inputs: Contact_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההודעה נשלחה!`)
};

const en_contact_success_title = /** @type {(inputs: Contact_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent!`)
};

/**
* | output |
* | --- |
* | "Message sent!" |
*
* @param {Contact_Success_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_title = /** @type {((inputs?: Contact_Success_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_success_title(inputs)
	return en_contact_success_title(inputs)
});